/**
 * Header — top app bar: brand, theme toggle, logout.
 */
import React from 'react';
import { Moon, Sun, LogOut, User } from 'lucide-react';

export default function Header({ user, theme, toggleTheme, onLogout, onProfile }) {
  const greetingName = user?.first_name || user?.email || 'there';

  return (
    <header className="app-header">
      <button className="app-header-brand app-header-brand-btn" onClick={onProfile} title="Edit profile">
        <span className="app-header-title">SafePlate</span>
        <span className="app-header-greeting">Hi, {greetingName}</span>
      </button>

      <div className="app-header-actions">
        <button
          className="header-profile-btn"
          onClick={onProfile}
          aria-label="Profile"
          title="Profile"
        >
          <User size={18} />
          <span>Profile</span>
        </button>
        <button
          className="icon-btn"
          onClick={toggleTheme}
          aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
          title="Toggle theme"
        >
          {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
        </button>
        <button
          className="icon-btn"
          onClick={onLogout}
          aria-label="Log out"
          title="Log out"
        >
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
}
